export default {
  methods: {
    updateStyleClassElement: function(style, classe) {
      let cssComposer = grapesjsEMP.editors[0].CssComposer;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        let classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            const oldStyle = cssComposer.getClassRule(classes[0]).attributes.style;
            const newStyle = Object.assign({}, oldStyle, style);
            const rule = cssComposer.setClassRule(classes[0], newStyle);
            this.$root.$emit('change-opacity', style['opacity'] * 100);
          } else {
            grapesjsEMP.editors[0].getSelected().addClass(classe);
            cssComposer.setClassRule(classe, style);
          }
        }
      }
    },
    addStyleClassElement: function(style, classe) {
      let cssComposer = grapesjsEMP.editors[0].CssComposer;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        grapesjsEMP.editors[0].getSelected().addClass(classe);
        cssComposer.setClassRule(classe, style);
      }
    },
    removeStyleClassElement: function(prefix_class) {
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        let classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          classes.forEach(classe => {
            if (classe.indexOf(prefix_class) >= 0) {
              grapesjsEMP.editors[0].getSelected().removeClass(classe);
            }
          });
        }
      }
    },
    updateClassGrapesElement: function(classElement) {
      const selected = grapesjsEMP.editors[0].getSelected();
      selected.addAttributes({ 'data-animation': 'fragment ' + classElement });
      selected.addAttributes({ animation: 'start' });
    },
    updateDelayGrapesElement: function(delay) {
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        const attributesElement = grapesjsEMP.editors[0].getSelected().getAttributes();
        const attributeDelay = { 'data-autoslide': delay, value: delay };
        const attributes = Object.assign(attributesElement, attributeDelay);
        grapesjsEMP.editors[0].getSelected().set('attributes', attributes);
      }
    },
    hasClassRegexSelectedElement: function(initClass) {
      let hasClass = false;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        let classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            classes.forEach(classe => {
              if (classe.indexOf(initClass) >= 0) {
                hasClass = true;
              }
            });
          }
        }
      }
      return hasClass;
    },
    getZIndexCurrentSlide: function() {
      let empZIndex = 0;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        let classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            classes.forEach(classe => {
              if (classe.indexOf('emp-z-index-') >= 0) {
                empZIndex = classe.substring(12);
              }
            });
          }
        }
      }
      return empZIndex;
    },
    getAllComponets: function() {
      return grapesjsEMP.editors[0].DomComponents.getComponents().models;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinAnimation.js